import { render } from "./SectionFaq.vue?vue&type=template&id=bb4d65de"
import script from "./SectionFaq.vue?vue&type=script&lang=js"
export * from "./SectionFaq.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__